import React from 'react';
import {
  Box,
  FormLabel,
  Input,
  InputGroup,
  InputRightElement,
} from '@chakra-ui/react';
import { Icon } from 'src/components/atoms/Icon';

type GroupNameInputProps = {
  label: string;
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
};

export const GroupNameInput: React.FC<GroupNameInputProps> = ({
  label,
  value,
  onChange,
  placeholder,
}) => {
  return (
    <Box>
      <FormLabel
        fontFamily="marketingPage"
        fontWeight="semibold"
        fontSize="sm"
        color="text.title"
        mb={2}>
        {label}
      </FormLabel>
      <InputGroup>
        <Input
          placeholder={placeholder}
          value={value}
          onChange={(e) => onChange(e.target.value)}
          border="1px solid"
          borderColor="border.box"
          borderRadius="md"
          fontFamily="marketingPage"
          _focus={{
            borderColor: 'icon.green',
            boxShadow: '0 0 0 1px var(--chakra-colors-icon-green)',
          }}
        />
        {placeholder && (
          <InputRightElement>
            <Icon iconName="pencil" boxSize={4} color="gray.400" />
          </InputRightElement>
        )}
      </InputGroup>
    </Box>
  );
};
